
    import "src/app/AppAdmin/Brands/Orders/index.module.scss?farm_css_modules";
    
    export default {"borderLessTag": `borderLessTag-8a92c20d`,"filterButton": `filterButton-8a92c20d`,"filterImage": `filterImage-8a92c20d`,"orderStatusFilter": `orderStatusFilter-8a92c20d`,"searchContainer": `searchContainer-8a92c20d`}
    